if (!customElements.get('lookbook-card')) {
  customElements.define(
    'lookbook-card',
    class LookbookCard extends ModalComponent {
      constructor() {
        super();

        this.card = this.closest('.lbcard');

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = () => {
          this.removeAttribute('open');
          document.body.classList.remove(this.classes.show);
        };
      }

      get isLockingNeeded() {
        return FoxTheme.config.mqlMobile;
      }
    
      get requiresBodyAppended() {
        return FoxTheme.config.mqlMobile;
      }

      get autoFocus() {
        return this._preventAutoFocus || false;
      }

      prepareToShow() {
        super.prepareToShow();
        this.card.classList.add('is-open');
      }

      handleAfterHide() {
        super.handleAfterHide();
        this.card.classList.remove('is-open');
        this.card.classList.add('is-closed');
      }

       openWithoutJump() {
        const scrollX = window.scrollX;
        const scrollY = window.scrollY;

        this._preventAutoFocus = true;

        this.setAttribute('open', '');

        requestAnimationFrame(() => {
          window.scrollTo(scrollX, scrollY);
          this._preventAutoFocus = false;
        });
      }
    }
  );
}

if (!customElements.get('lookbook-card-wrapper')) {
  customElements.define(
    'lookbook-card-wrapper',
    class LookbookCardWrapper extends HTMLElement {
      constructor() {
        super();
      }

      get video() {
        return this.querySelector('video-element');
      }

      connectedCallback() {
        if (!this.video) return;

        this.addEventListener('mouseleave', this.handleMouseInteraction.bind(this, 'leave'));
        this.addEventListener('mouseenter', this.handleMouseInteraction.bind(this, 'enter'));
      }

      disconnectedCallback() {
        this.removeEventListener('mouseleave');
        this.removeEventListener('mouseenter');
      }

      handleMouseInteraction(type, event) {
        if (type === 'enter') {
          this.classList.add('is-hovering');
          this.video.play();
        } else {
          this.classList.remove('is-hovering');
          this.video.pause();
        }
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const firstCard = document.querySelector('lookbook-card');
  const cardWrapper = firstCard?.closest('.lbcard');
  const isMobile = FoxTheme.config.mqlMobile === true;

  if (!firstCard || !cardWrapper) return;

  const btn = cardWrapper.querySelector('.lbcard__popup-btn-trigger');

  if (!isMobile) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          firstCard.openWithoutJump();
          cardWrapper.classList.add('is-open');
          cardWrapper.classList.remove('is-closed');
          if (btn) btn.style.visibility = 'hidden';

          observer.unobserve(cardWrapper);
        }
      });
    }, {
      threshold: 0.5 
    });

    observer.observe(cardWrapper);

  } else {
    firstCard.removeAttribute('open');
    cardWrapper.classList.remove('is-open');
    cardWrapper.classList.add('is-closed');
    if (btn) btn.style.visibility = 'visible';
  }

  document.querySelectorAll('.lbcard').forEach(card => {
    const btn = card.querySelector('.lbcard__popup-btn-trigger');
    card.addEventListener('transitionend', () => {
      if (card.classList.contains('is-closed') && btn) {
        btn.style.visibility = 'visible';
      }
    });
  });
});
